export default __webpack_public_path__ + "static/media/photo--sm--rob.2194f4bc.jpg";